import React from "react"; 
import Header from "../components/Header";
import Footer from "../components/Footer"; 
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from "react-lazyload";
const ManagementCommittee = () => {

  return (
    <>
      <Header />
      <Breadcrumb mid="Academics" breadcrumbName="Management Committee" />

      <div className="innerSection">
        <div className="container">         
          <div className="row">
            <div className="col-md-12">
            <div className="title">
                <div>
                    <h1>Management Committee</h1>
                </div>
            </div>
               
            </div>
            <div className="col-md-4 mt-4">
              <div className="management_commit">
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/principal-Reginald.JPG" alt="St mary school, mirzapur" /></LazyLoad>
                <h3>Rev. Fr. Reginald D'Souza</h3>
                <p>PRINCIPAL </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="management_commit">
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Louis-Mascarenhas-1.jpg" alt="St mary school, mirzapur" /></LazyLoad>
                <h3>Most. Rev. Dr. Louis Mascarenhas</h3>
                <p>(BISHOP OF ALLAHABAD)</p>
                <p>CHAIRMAN OF ST. MARY'S EDU. SOCIETY</p>
              </div>
            </div>
            
            <div className="col-md-4 mt-4">
              <div className="management_commit">
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/Fr-Melwin-Wilson.jpg" alt="St mary school, mirzapur" /></LazyLoad>
                <h3>Rev. Fr. Melwin Wilson D'Souza</h3>
                <p>Diocesan Education Officer</p>
              </div>
            </div>
            
          
          </div>
        </div>
      </div>
      <Footer /> 
    </>
  )
}

export default ManagementCommittee